export default "__VITE_ASSET__CYDvOjJT__"